const galleryData = [
    {
        img: 'http://via.placeholder.com/500x330',
        title: 'Breakfast',
    },

    {
        img: 'http://via.placeholder.com/500x330',
        title: 'Honey',
    },
    {
        img: 'http://via.placeholder.com/500x330',
        title: 'Vegetables',
    },

    {
        img: 'http://via.placeholder.com/500x330',
        title: 'Olive oil',
    },
    {
        img: 'http://via.placeholder.com/500x330',
        title: 'Blue Bird',
    },
    {
        img: 'http://via.placeholder.com/500x330',
        title: 'Morning',
    },

];

export default galleryData;



// WEBPACK FOOTER //
// ./components/dashboard/Common/PhotoCollage/galleryData.js